export enum EFlightCategory {
  'VFR' = 'VFR',
  'MVFR' = 'MVFR',
  'IFR' = 'IFR',
  'LIFR' = 'LIFR',
  'NA' = 'NA',
}
